import apiSession from "@/api/session.js";

const state = {
  modelType: 1,
  modelTypeList: [
    { label: "ChatGPT-3.5", value: 1 },
    { label: "ChatGPT-4", value: 2 },
    { label: "文心一言", value: 3 },
  ],
  sessionTitleList: [],
};

const mutations = {
  setModelType(state, modelType) {
    modelType = state.modelTypeList
      .map(({ value }) => value)
      .includes(modelType)
      ? modelType
      : 1;
    state.modelType = modelType;
    localStorage.setItem("session/modelType", `${modelType}`);
  },
  setSessionTitleList(state, sessionTitleList) {
    state.sessionTitleList = sessionTitleList;
  },
};

const actions = {
  // 获取会话列表接口
  async fetchSessionTitleList({ state }) {
    const model = state.modelType;
    const params = { model };
    return await apiSession.fetchSessionTitleList(params);
  },

  // 获取会话列表操作
  async handleFetchSessionTitleList({ commit, dispatch }) {
    let { data } = await dispatch("fetchSessionTitleList").catch((error) => {
      console.error("handleFetchSessionTitleList");
      throw error;
    });
    data = Array.isArray(data)
      ? data.map((item) => {
          const { messageId, message } = item;
          return { id: messageId, title: message };
        })
      : [];
    commit("setSessionTitleList", data);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
